import { Pipe, PipeTransform } from "@angular/core";
import { parseZone } from "moment-timezone";

@Pipe({
  name: "customTime",
  pure: true
})
export class CustomTimePipe implements PipeTransform {
  transform(value: number, timezone: string, format = "hh:mm A"): string {
    return parseZone(value)
      .tz(timezone || parseZone().zoneName())
      .format(format);
  }
}
